import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-modal',
  imports: [ButtonModule, CommonModule, DialogModule],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss'
})
export class ModalComponent {

@Input() header: string ='';
@Input() showDialog: boolean = false;
@Output() showDialogChange: EventEmitter<any> = new EventEmitter();
@Input() rejectLabel: string ='';
@Input() acceptLabel: string ='';
@Input() saveLabel: string ='';
@Output() acceptModalClick: EventEmitter<any> = new EventEmitter();
@Output() rejectModalClick: EventEmitter<any> = new EventEmitter();
@Output() saveModalClick: EventEmitter<any> = new EventEmitter();


accept() {
  this.acceptModalClick.emit();
}

reject() {
  this.rejectModalClick.emit();
}

save() {
  this.saveModalClick.emit(); 
}

}
